/**
 * The visitor's A/B bucket, or `undefined` outside an A/B-tested site.
 *
 * A site that runs A/B tests draws the bucket in an inline head script and
 * writes it on the root element as `data-ab-bucket` before any of its own code
 * runs (heni-websites' `src/app.html`). Reading it there, rather than from the
 * cookie, keeps this helper free of the cookie's name and format, and means the
 * entry-point screen view carries it too.
 */
export const getAbBucket = (): number | undefined => {
	if (typeof document === 'undefined') {
		return undefined;
	}

	const raw = document.documentElement.getAttribute('data-ab-bucket');
	const bucket = raw === null || raw === '' ? Number.NaN : Number(raw);

	return Number.isInteger(bucket) && bucket >= 0 ? bucket : undefined;
};
